import React from 'react';
import { ContentContainer } from '@tmobile/tmo-bps-syncup-web-component-lib';
import Authorized from '../../auth/Authorized';
import { SUA_ROLES } from '../../utils/app_constants';
import DisplayRatePlans from '../../components/RatePlan/DisplayRatePlans';

import style from '../../components/appVersions/AppVersionsList.module.css';

/**
 * Role Groups for easier maintenance
 * Grouped by product/module to avoid repetition
 */
const PETS_ROLES = [
  SUA_ROLES.PETS_ADMIN,
  SUA_ROLES.PETS_DEV,
  SUA_ROLES.PETS_PO
];
const TRACKER_ROLES = [
  SUA_ROLES.TRACKER_ADMIN,
  SUA_ROLES.TRACKER_DEV,
  SUA_ROLES.TRACKER_PO
];
const WATCH_ROLES = [
  SUA_ROLES.WATCH_ADMIN,
  SUA_ROLES.WATCH_DEV,
  SUA_ROLES.WATCH_PO
];

/**
 * All roles allowed to access the RatePlanPage
 * Note: SYNCUP_DPI is temporary and should be removed after testing
 */
const ALLOWED_ROLES = [
  SUA_ROLES.ADMIN,
  SUA_ROLES.MOBILE_APP_DEVS,
  SUA_ROLES.SYNCUP_DPI, // TO-DO: Remove after testing
  SUA_ROLES.PO,
  ...PETS_ROLES,
  ...TRACKER_ROLES,
  ...WATCH_ROLES
];

/**
 * RatePlanPage Component
 * - Wrapped in Authorized to enforce role-based access
 * - Displays the Rate Plans inside a styled ContentContainer
 */
function RatePlanPage() {
  return (
    <Authorized roles={ALLOWED_ROLES} willShowErrorModal>
      <ContentContainer className={style.container}>
        <DisplayRatePlans />
      </ContentContainer>
    </Authorized>
  );
}

export default RatePlanPage;
